
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"147","height":"40","viewBox":"0 0 147 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M16.585 8.31c2.577 6.538-1.68 10.748-5.827 14.848C6.725 27.479 3.364 31.911 10.31 40c-2.577-6.537 1.68-10.748 5.827-14.848 3.921-4.32 7.394-8.753.448-16.842z","fill":"#E9444B"}}),_c('path',{attrs:{"d":"M10.31 0c2.577 6.537-1.568 10.748-5.826 14.848-3.921 4.321-7.395 8.753-.448 16.73-2.69-6.426 1.569-10.636 5.826-14.847C13.784 12.41 17.257 7.978 10.31 0zM116.975 25.817v13.297h5.938v-4.876h6.499v-2.88h-6.499v-2.66h12.773v10.416h5.939V28.698h5.378v-2.88h-30.028zM104.314 36.233v-2.327h7.73v-2.881h-7.73v-2.327h9.859v-2.88H98.375v13.296h15.91v-2.881h-9.971z","fill":"#71BB74"}}),_c('path',{attrs:{"d":"M42.127 25.817H25.768v2.881h5.266v10.416h5.827V28.698h5.266v-2.88zM53.784 25.817h-4.482v3.213l.112-.11 2.577 5.097h-2.689v2.77h4.146l1.232 2.327h6.498l-7.394-13.297zm-4.594 0h-1.793l-7.395 13.297h3.81l1.232-2.327h4.146v-2.77H46.5l2.69-4.987v-3.213z","fill":"#E9444B"}}),_c('path',{attrs:{"d":"M91.207 25.817v6.648l-9.524-6.648H77.2v13.297h4.034V31.8l9.635 7.313h4.37V25.817h-4.033z","fill":"#71BB74"}}),_c('path',{attrs:{"d":"M75.184 25.817H59.163v2.881h5.265v10.416h5.826V28.698h4.93v-2.88z","fill":"#E9444B"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h147v40H0z"}})])])])
          )
        }
      }
    